import React, { useEffect, useState } from 'react';
import { Space, Table, Tag, Card, Popconfirm } from 'antd';

import { Button, Checkbox, Form, Input, Image, Descriptions } from 'antd';
import ImagePicker from "components/pickers/image/MultiImagePicker"
import { useParams, useNavigate } from "react-router"
import ProductService from 'services/product';
import { formatCurrency } from "@/utilities/number"
const service = new ProductService();

const EditProductPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    loadData();
  }, [id])

  const [data, setData] = useState({ images: [] })

  const loadData = async () => {
    var item = await service.get(id);
    setData(item)
  }

  const deleteProduct = async () => {

    var data = await service.delete(id);
    navigate("/products");
  }
  const hideProduct = async () => {
    var data = await service.hide(id);
    navigate("/products");
  }
  const unhideProduct = async () => {
    var data = await service.unhide(id);
    navigate("/products");
  }

  const outOfStock = async (outOf) => {
    var data = await service.outOfStock(id, outOf);
    navigate("/products");
  }



  return (

    <div>
      <Space direction="vertical" size={16} style={{ width: "100%" }}>
        <Card size="small" title="Thông tin cơ bản" extra={<Space>
          <Popconfirm
            title="Xoá sản phẩm"
            description="Bạn có chắc chắn muốn xoá sản phẩm này"
            onConfirm={deleteProduct}
            okText="Yes"
            cancelText="No"
          >
            <Button type='link' danger >Delete</Button>

          </Popconfirm>

          {data.hide &&

            <Popconfirm
              title="Hiện thị"
              description="Bạn có chắc chắn muốn hiển thị sản phẩm này"
              onConfirm={unhideProduct}
              okText="Yes"
              cancelText="No"
            >
              <Button type='link' danger >Hiển thị trên web </Button>
            </Popconfirm>

          }


          {!data.hide &&
            <Popconfirm
              title="Ẩn"
              description="Bạn có chắc chắn muốn ẩn sản phẩm này"
              onConfirm={hideProduct}
              okText="Yes"
              cancelText="No"
            >
              <Button type='link' danger >Ẩn trên web</Button>
            </Popconfirm>

          }




          {data.out_of_stock &&

            <Popconfirm
              title="Còn Hàng"
              description="Bạn có chắc chắn muốn cập nhật sản phẩm còn hàng "
              onConfirm={e => outOfStock(false)}
              okText="Yes"
              cancelText="No"
            >
              <Button type='link' danger >Còn hàng</Button>
            </Popconfirm>

          }


          {!data.out_of_stock &&

            <Popconfirm
              title="Còn Hàng"
              description="Bạn có chắc chắn muốn cập nhật sản phẩm hết hàng "
              onConfirm={e => outOfStock(true)}
              okText="Yes"
              cancelText="No"
            >
              <Button type='link' danger >Hết hàng</Button>
            </Popconfirm>

          }












          <Button type='link' onClick={e => navigate(`/product/info/${id}`)}>Edit</Button>

        </Space>} style={{ width: "100%" }}>


          <Descriptions bordered layout={"horizontal"}>
            <Descriptions.Item label="Tên" span='filled'  >         {data.name}</Descriptions.Item>
            <Descriptions.Item label="Hình ảnh" span='filled'  >       <Image.PreviewGroup
              preview={{
                onChange: (current, prev) => console.log(`current index: ${current}, prev index: ${prev}`),
              }}
            >
              <Space direction='horizontal'>


                {data.images.map(img => {
                  return (

                    <Image width={75} src={img.url} />
                  )
                })}
              </Space>


            </Image.PreviewGroup></Descriptions.Item>

            <Descriptions.Item label="Giá" span='filled'  >       {formatCurrency(data.original_price)}</Descriptions.Item>

            <Descriptions.Item label="Mô tả" span='filled'  >          {data.description}</Descriptions.Item>
          </Descriptions>

        </Card>


        <Card size="small" title="Biến thể" extra={<Space>  <Button type='link' onClick={e => navigate(`/product/variant/${id}`)}>Biến thể</Button>  <Button type='link' onClick={e => navigate(`/product/price/${id}`)}>Bảng giá</Button>   </Space>} style={{ width: "100%" }}>
          <div>



            <div>
              <Table style={{ width: "100%" }} pagination={false} dataSource={data.variants} columns={[

                {
                  title: 'Biến thể',
                  render: (_, { images = [], variant_id, variant_title }) => {
                    return (
                      <div>
                        <Space>

                          {variant_title}
                         

                        </Space>

                      </div>
                    )
                  }
                },

                {
                  title: 'Giá',
                  render: (_, { images, variant_id, original_price }) => {
                    return (
                      <div style={{ textAlign: "right", width: 75 }}>
                        {formatCurrency(original_price)}
                      </div>
                    )
                  }
                },


                {
                  title: 'Giá theo số lượng',
                  render: (_, { images, variant_id, original_price, price_list = [] }) => {
                    return (
                      
                        price_list.map(x => {
                          return (
                            <div style={{ display: "flex" }}>
                              <div style={{ width: 75 }}>
                                Từ {x.min}
                              </div>
                              <div style={{ width: 75 }}>
                                <b>{formatCurrency(x.price)}</b>
                              </div>
                              <div style={{ marginLeft: 16 }}>Giảm {formatCurrency((x.price - original_price) * -1)}</div>
                            </div>
                          )
                        })
                      
                    )
                  }
                },




              ]} />
            </div>



          </div>


        </Card>



      </Space>
    </div>

  )
};
export default EditProductPage;